import { navigate } from 'gatsby';
import React, { FC, useState } from 'react';
import styled from 'styled-components';

import BasicText from '@ui/atoms/BasicText';
import Button from '@ui/atoms/Button';
import FlexColumn, { IFlexColumn } from '@ui/atoms/FlexColumn';
import NavigationSection from '@ui/atoms/NavigationSection';
import SelectableButton from '@ui/atoms/SelectableButton';
import StyledLink from '@ui/atoms/StyledLink';

import CenteredGridItem from '@ui/molecules/CenteredGridItem';

import fullWidth from '@ui/styled/FullWidth';
import spaced from '@ui/styled/Spaced';

import { IPageProps } from '@folx-types/flow-steps';

import theme from '@theme/FolxTheme';

export interface IMemberGAHTConsultGetCareStepContent {
	description: string;
	intakeSelection: string;
	testosteroneTitle: string;
	testosteroneDescription: string;
	estrogenTitle: string;
	estrogenDescription: string;
	libraryTitle: string;
	libraryDescription: string;
}

interface IMemberGAHTConsultGetCareStepProps extends IPageProps {
	pageContent: IMemberGAHTConsultGetCareStepContent;
}

const FullWidthColumn = fullWidth<IFlexColumn>(FlexColumn);
const SpacedColumn = spaced<IFlexColumn>(FullWidthColumn);
const SpacedGridItem = spaced(CenteredGridItem);

const StyledLinkSm = styled(StyledLink)`
	${BasicText} {
		font-size: ${theme.fontSizes.body.xs};
	}
`;

const MemberGAHTConsultGetCareStep: FC<IMemberGAHTConsultGetCareStepProps> = ({ pageContent }) => {
	const {
		description,
		intakeSelection,
		libraryTitle,
		libraryDescription,
		testosteroneTitle,
		testosteroneDescription,
		estrogenTitle,
		estrogenDescription,
	} = pageContent;
	const [selectedFlow, setSelectedFlow] = useState('');
	return (
		<SpacedColumn gap="lg" marginBottom="lg">
			<SpacedColumn gap="md" marginBottom="lg">
				<BasicText>{description}</BasicText>
				<SpacedColumn gap="sm">
					<BasicText variant="field">{intakeSelection}</BasicText>
					<SelectableButton
						optionValue={'hrt_t_sub'}
						optionLabel={testosteroneTitle}
						key={'T'}
						value={selectedFlow}
						alignment="start"
						onChange={(v) => {
							setSelectedFlow(v);
						}}>
						<SpacedColumn gap="xs">
							<BasicText variant="field">{testosteroneTitle}</BasicText>
							<BasicText variant="smallText">{testosteroneDescription}</BasicText>
						</SpacedColumn>
					</SelectableButton>
					<SelectableButton
						optionValue={'hrt_e_sub'}
						optionLabel={estrogenTitle}
						key={'E'}
						value={selectedFlow}
						alignment="start"
						onChange={(v) => {
							setSelectedFlow(v);
						}}>
						<SpacedColumn gap="xs">
							<BasicText variant="field">{estrogenTitle}</BasicText>
							<BasicText variant="smallText">{estrogenDescription}</BasicText>
						</SpacedColumn>
					</SelectableButton>
				</SpacedColumn>
				<BasicText variant="fineprint">{libraryDescription}</BasicText>
				<StyledLinkSm to={'https://www.folxhealth.com/library'} variant="underline" newTab={true}>
					{libraryTitle}
				</StyledLinkSm>
			</SpacedColumn>
			<SpacedGridItem>
				<NavigationSection>
					<Button label="Back" onClick={() => navigate('/app/member/get_care')} />
					<Button
						label="Next"
						variant="secondary"
						disabled={!selectedFlow}
						onClick={() => navigate(`/app/flows/${selectedFlow}?isConsult=true`)}
					/>
				</NavigationSection>
			</SpacedGridItem>
		</SpacedColumn>
	);
};

export default MemberGAHTConsultGetCareStep;
